import { httpClient } from './http-client';

export default {
	getCaptcha() {
		return httpClient.get('/api/captcha');
	}
};
